import theme, {
    DRAWER_WIDTH, HEADER_HEIGHT
} from '@services/theme'

const drawerBase = {
    paddingTop: HEADER_HEIGHT,
    width: DRAWER_WIDTH,
    backgroundColor: theme.palette.leftPanel.background
}

export default {
    body: {
        display: 'flex',
        minHeight: '100dvh',
        paddingLeft: 0,
        overflow: 'hidden',
        overflowY: 'hidden',
        backgroundColor: theme.palette.body.background
    },
    drawer: {
        [`& .MuiDrawer-paper`]: drawerBase
    },
    drawerDisplayed: {
        paddingLeft: DRAWER_WIDTH
    }
}